import { useState } from 'react';
import classNames from 'classnames';
import { t } from 'ttag';

import SafePaymentIcon from '@svg/safe-payment.svg';
import MessageInfoIcon from '@svg/message-info.svg';
import { Button } from '@ui/Button';
import { Alert } from '@ui/Alert';
import { SafePaymentBenefitsModal } from '@components/SafePaymentBenefitsModal';

import s from './ProductDetailsSafePaymentBanner.sss';

interface Props {
  className?: string,
}

export const ProductDetailsSafePaymentBanner: React.FC<Props> = ({
  className,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggleModal = () => {
    setIsModalOpen((prevState) => !prevState);
  };

  return (
    <>
      <Button
        className={classNames(s.root, className)}
        theme="text"
        onClick={handleToggleModal}
      >
        <Alert className={s.alert}>
          <SafePaymentIcon
            className={s.icon}
            width="48"
            height="48"
          />
          <div className={s.info}>
            <p className={s.title}>
              {t`Купуйте цей товар з Безпечною оплатою`}
            </p>
            <p className={s.description}>
              {t`Повернемо гроші, якщо він не підійде `}
            </p>
          </div>
          <MessageInfoIcon
            className={s.infoIcon}
            width="16"
            height="16"
          />
        </Alert>
      </Button>
      <SafePaymentBenefitsModal
        isOpen={isModalOpen}
        onClose={handleToggleModal}
      />
    </>
  );
};
